module.exports = __webpack_public_path__ + "img/k3.add38429.png";